export enum IModalPreviewType {
  PREVIEW = 'PREVIEW',
  COPY = 'COPY',
}
